import actionTypes from '../../action-types'

export default (payload, meta, included) => ({
  type: actionTypes.APPS.SET_ALL,
  payload,
  meta,
  included,
})
